import { createZigzagHopFrames } from "../../core/directional-hop-keyframes.js";

export const meta = Object.freeze({
  id: "hop-zigzag",
  label: "Großes Zickzack",
  duration: 4200,
  description: "Fünf große Hüpfer: links, rechts, links, rechts und zurück zur Mitte.",
  tags: ["body", "directional", "zigzag", "one-shot", "loopable"],
});

export async function run({ elements, animate }) {
  const frames = createZigzagHopFrames();
  const body = animate(elements.actor, frames.body, { duration: meta.duration, easing: "linear" });
  const shadow = animate(elements.shadow, frames.shadow, { duration: meta.duration, easing: "linear" });
  await Promise.allSettled([body.finished, shadow.finished]);
}
